"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "AdminTool_"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.5,17.54c-.39-1.28-2.28-2.54-6.5-4.31v-1a4.06,4.06,0,0,0,1.49-3.22,1.77,1.77,0,0,0,.6-1.5,2,2,0,0,0-.48-1.4A6.6,6.6,0,0,0,19,2.83a3.21,3.21,0,0,0-1.85-2,2.37,2.37,0,0,0-2.41.25.6.6,0,0,0-.14.77.48.48,0,0,0,.7.15,1.44,1.44,0,0,1,1.49-.14A2.22,2.22,0,0,1,18,3.1a5.67,5.67,0,0,1-.36,2.75,2.12,2.12,0,0,0-.15.62A.48.48,0,0,0,18,7a1,1,0,0,1,.13.56,1.84,1.84,0,0,1-.09.55.53.53,0,0,0-.5.55c0,2.19-1.15,2.77-1.19,2.79A.56.56,0,0,0,16,12v1.65a.55.55,0,0,0,.32.51c1.44.6,5.82,2.41,6.23,3.77A21.94,21.94,0,0,1,23,22.4H21.5a.55.55,0,0,0,0,1.1h2A.53.53,0,0,0,24,23,26.87,26.87,0,0,0,23.5,17.54Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.51,8.51A4.06,4.06,0,0,0,7,11.73v2l-1.29.51c-2.57,1-4.8,1.89-5.21,3.25A26.87,26.87,0,0,0,0,23a.53.53,0,0,0,.5.55h18A.53.53,0,0,0,19,23a26.87,26.87,0,0,0-.5-5.41c-.41-1.36-2.48-2.17-5.09-3.2L12,13.78v-2a4.06,4.06,0,0,0,1.49-3.22A1.77,1.77,0,0,0,14.09,7a2,2,0,0,0-.47-1.4A5.79,5.79,0,0,0,14,2.49C13.65,1,11.77.5,10.25.5,8.91.5,7.27.91,6.69,2a1.38,1.38,0,0,0-1.28.56c-.52.76-.28,2,0,3A1.83,1.83,0,0,0,4.88,7,1.68,1.68,0,0,0,5.51,8.51Z",
    fill: "#024965"
  }), ' ');
};

exports["default"] = _default;